const themes = {
    "default": {
      quote_color: "#2f80ed",
      author_color: "#333",
      bg_color: "#fffefe",
    },
    "default_repocard": {
      quote_color: "#2f80ed",
      author_color: "#333",
      bg_color: "#fffefe",
    },
    "dark": {
      quote_color: "#fff",
      author_color: "#9f9f9f",
      bg_color: "#151515",
    },
    "radical": {
      quote_color: "#fe428e",
      author_color: "#a9fef7",
      bg_color: "#141321",
    },
    "merko": {
      quote_color: "#abd200",
      author_color: "#68b587",
      bg_color: "#0a0f0b",
    },
    "gruvbox": {
      quote_color: "#fabd2f",
      author_color: "#8ec07c",
      bg_color: "#282828",
    },
    "tokyonight": {
      quote_color: "#70a5fd",
      author_color: "#38bdae",
      bg_color: "#1a1b27",
    },
    "onedark": {
      quote_color: "#e4bf7a",
      author_color: "#df6d74",
      bg_color: "#282c34",
    },
    "cobalt": {
      quote_color: "#e683d9",
      author_color: "#75eeb2",
      bg_color: "#193549",
    },
    "synthwave": {
      quote_color: "#e2e9ec",
      author_color: "#e5289e",
      bg_color: "#2b213a",
    },
    "highcontrast": {
      quote_color: "#e7f216",
      author_color: "#fff",
      bg_color: "#000",
    },
    "dracula": {
      quote_color: "#ff6e96",
      author_color: "#f8f8f2",
      bg_color: "#282a36",
    },
    "prussian": {
      quote_color: "#bddfff",
      author_color: "#6e93b5",
      bg_color: "#172f45",
    },
    "monokai": {
      quote_color: "#eb1f6a",
      author_color: "#f1f1eb",
      bg_color: "#272822",
    },
    "vue": {
      quote_color: "#41b883",
      author_color: "#273849",
      bg_color: "#fffefe",
    },
    "vue-dark": {
      quote_color: "#41b883",
      author_color: "#fffefe",
      bg_color: "#273849",
    },
    "shades-of-purple": {
      quote_color: "#fad000",
      author_color: "#a599e9",
      bg_color: "#2d2b55",
    },
    "nightowl": {
      quote_color: "#c792ea",
      author_color: "#7fdbca",
      bg_color: "#011627",
    },
    "buefy": {
      quote_color: "#7957d5",
      author_color: "#363636",
      bg_color: "#ffffff",
    },
    "blue-green": {
      quote_color: "#2f97c1",
      author_color: "#0cf574",
      bg_color: "#040f0f",
    },
    "algolia": {
      quote_color: "#00AEFF",
      author_color: "#FFFFFF",
      bg_color: "#050F2C",
    },
    "great-gatsby": {
      quote_color: "#ffa726",
      author_color: "#ffd95b",
      bg_color: "#000000",
    },
    "darcula": {
      quote_color: "#BA5F17",
      author_color: "#BEBEBE",
      bg_color: "#242424",
    },
    "bear": {
      quote_color: "#e03c8a",
      author_color: "#bcb28d",
      bg_color: "#1f2023",
    },
    "solarized-dark": {
      quote_color: "#268bd2",
      author_color: "#859900",
      bg_color: "#002b36",
    },
    "solarized-light": {
      quote_color: "#268bd2",
      author_color: "#859900",
      bg_color: "#fdf6e3",
    },
    "chartreuse-dark": {
      quote_color: "#7fff00",
      author_color: "#fff",
      bg_color: "#000",
    },
    "nord": {
      quote_color: "#81a1c1",
      author_color: "#d8dee9",
      bg_color: "#2e3440",
    },
    "gotham": {
      quote_color: "#2aa889",
      author_color: "#99d1ce",
      bg_color: "#0c1014",
    },
    "material-palenight": {
      quote_color: "#c792ea",
      author_color: "#a6accd",
      bg_color: "#292d3e",
    },
    "graywhite": {
      quote_color: "#24292e",
      author_color: "#24292e",
      bg_color: "#ffffff",
    },
    "vision-friendly-dark": {
      quote_color: "#ffb000",
      author_color: "#ffffff",
      bg_color: "#000000",
    },
    "ayu-mirage": {
      quote_color: "#f4cd7c",
      author_color: "#c7c8c2",
      bg_color: "#1f2430",
    },
    "midnight-purple": {
      quote_color: "#9745f5",
      author_color: "#ffffff",
      bg_color: "#000000",
    },
    "calm": {
      quote_color: "#e07a5f",
      author_color: "#ebcfb2",
      bg_color: "#373f51",
    },
    "flag-india": {
      quote_color: "#ff8f1c",
      author_color: "#509E2F",
      bg_color: "#ffffff",
    },
    "omni": {
      quote_color: "#FF79C6",
      author_color: "#E1E1E6",
      bg_color: "#191622",
    },
    "react": {
      quote_color: "#61dafb",
      author_color: "#ffffff",
      bg_color: "#20232a",
    },
    "jolly": {
      quote_color: "#ff64da",
      author_color: "#ffffff",
      bg_color: "#291B3E",
    },
    "maroongold": {
      quote_color: "#F7EF8A",
      author_color: "#E0AA3E",
      bg_color: "#260000",
    },
    "yeblu": {
      quote_color: "#ffff00",
      author_color: "#ffffff",
      bg_color: "#002046",
    },
    "blueberry-light": {
      quote_color: "#82aaff",
      author_color: "#27e7a6",
      bg_color: "#fffeff"
    },
    "blueberry-dark": {
      quote_color: "#82aaff",
      author_color: "#27e8a7",
      bg_color: "#242938"
    },
    "slateorange": {
      quote_color: "#faa627",
      author_color: "#ffffff",
      bg_color: "#36393f"
    },
    "kacho_ga": {
      quote_color: "#bf4a3f",
      author_color: "#d9c8a9",
      bg_color: "#402b23"
    },
    "soft-green": {
      quote_color: "#00dc4d",
      author_color: "#cecece",
      bg_color: "#222428"
    },
    "blood": {
      quote_color: "#ff6060",
      author_color: "#367391",
      bg_color: "#fffefe"
    },
    "blood-dark": {
      quote_color: "#fe5f5f",
      author_color: "#357290",
      bg_color: "#142b37"
    }
  };
  

  export default themes;